module.exports = __webpack_public_path__ + "media/AG-Learning.4bf0f5ab.mp4";